import Choices from 'choices.js';

async function initChoices() {
    const selectElements = document.querySelectorAll('.js-choices');

    // for each select element, create a new Choices instance
    selectElements.forEach((select) => {
        new Choices(select, {
            itemSelectText: '',
            searchEnabled: false,
            searchChoices: true,
            fuseOptions: {
                includeScore: true,
            },
            position: 'auto',
            searchFields: ['label'],
            sorter: function(a, b) {
                //@ts-ignore
                return b.label - a.label;
            },
            callbackOnInit: function (){
                // @ts-ignore
                const container = this.containerOuter.element;
                setTimeout(() => {
                    container.classList.add('show');
                },20);
            }
        });
        // @ts-ignore
        select.addEventListener('choice', (event) => {
            const url = event.detail.value;
            window.location.href = url;
        });
    });
}

export { initChoices };